import { ModalProps, Modal } from "antd";
import "./style.css";

interface YudlModalProps extends ModalProps {}

const YudlModal = ({ ...props }: YudlModalProps) => (
  <Modal bodyStyle={{ ...props.bodyStyle, background: "#F8F5FF" }} zIndex={1100} {...props} />
);

export default YudlModal;
